import { Link } from '@mui/icons-material'
import { Button, Tooltip } from '@mui/material'
import { useRef, useState } from 'react'
import { CopyLinkMenu } from '@/features/search/SearchResults/actions/CopyMenu'
import type { PreviewButtonProps } from './Buttons'

export const CopyButton = (props: PreviewButtonProps) => {
  const { searchResultItem, visible } = props
  const ref = useRef(null)
  const [open, setOpen] = useState(false)

  if (!visible) return null

  return (
    <>
      <Tooltip title="Copy Media Link" placement="top">
        <Button ref={ref} onClick={() => setOpen(true)}>
          <Link />
        </Button>
      </Tooltip>

      <CopyLinkMenu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={ref.current}
        item={searchResultItem}
      />
    </>
  )
}
